// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__ZUHw7","file":"styles_file__1i-bx"};